import React, { useState } from "react";
import Login from "../pages/LogIn";
import Register from "../pages/Register/Register";
import RegisterBusiness from "./RegisterBusiness";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";
const Form = () => {
  const location = useLocation();
  return (
    <>
      {/* <Navbar /> */}
      {location.pathname === "/login" ? (
        <Login />
      ) : location.pathname === "/register" ? (
        <Register />
      ) : location.pathname === "/registerAsBusiness" ? (
        <RegisterBusiness />
      ) : null}
      <Footer />
    </>
  );
};

export default Form;
